<div class="lokos-button-toggle" [ngClass]="className">
	<mat-button-toggle-group [formControl]="control">
		@for (item of options; track $index) {
		<mat-button-toggle [value]="item">{{item.location | translate }}</mat-button-toggle>
		}
	</mat-button-toggle-group>
</div>